import React, { ReactNode } from 'react';
import { Tabs, Tab, TabsProps, TabProps, SxProps, Theme } from '@mui/material';
import { NeonTabsContainer } from './styles';
import { Box } from '@mui/material';

export interface NeonTabsProps {
  children: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  variant?: TabsProps['variant'];
  scrollButtons?: TabsProps['scrollButtons'];
  a11yPrefix?: string;
  tabsProps?: Omit<TabsProps, 'value' | 'onChange' | 'children'>;
  sx?: SxProps<Theme>;
}

export const a11yProps = (index: number, prefix: string = 'tab') => {
  return {
    id: `${prefix}-${index}`,
    'aria-controls': `${prefix}-tabpanel-${index}`,
  };
};

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  prefix?: string;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, prefix = 'tab', ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${prefix}-tabpanel-${index}`}
      aria-labelledby={`${prefix}-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

const NeonTabs: React.FC<NeonTabsProps> = ({
  children,
  value,
  onChange,
  variant = 'scrollable',
  scrollButtons = 'auto',
  a11yPrefix = 'tab',
  tabsProps,
  sx,
}) => {
  return (
    <NeonTabsContainer sx={sx}>
      <Tabs
        value={value}
        onChange={onChange}
        variant={variant}
        scrollButtons={scrollButtons}
        textColor="primary"
        indicatorColor="primary"
        aria-label="neon tabs"
        {...tabsProps}
      >
        {children}
      </Tabs>
    </NeonTabsContainer>
  );
};

export default NeonTabs; 